import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LayoutContext } from '../../contexts/layout.context';
import { useDispatch, useSelector } from 'react-redux';

import { authSelectors } from '../../store/selectors/auth';
import { getProfileThunk } from '../../store/thunks/profile';

import Head from '../../components/Head/Head';
import CardSettings from '../../components/Settings/CardSettings/CardSettings';
import GoogleCalendarCard from '../../components/Settings/GoogleCalendarCard/GoogleCalendarCard';

import { items } from './constants';

const Settings = () => {
  const { setLayout } = useContext(LayoutContext);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const auth = useSelector(authSelectors);
  const token = auth.token;

  // Повернення з Google: /settings?google_calendar=success|error&code=<код помилки>
  const [calendarFlash, setCalendarFlash] = useState(null);

  // Прихід із анонсу календаря: /settings?highlight=google-calendar —
  // доскролюємо до картки і підсвічуємо її, щоб людина не шукала очима.
  const [highlightCalendar, setHighlightCalendar] = useState(false);
  const calendarAnchor = useRef(null);

  useEffect(() => {
    document.title = 'Налаштування | New Brain';
    setLayout({ page: 'Налаштування' });
  }, [setLayout]);

  useEffect(() => {
    if (token) {
      dispatch(getProfileThunk({ token }));
    }
  }, [token]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get('google_calendar');

    if (!status) {
      return;
    }

    setCalendarFlash({ status: status, code: params.get('code') || '' });

    // Прибираємо параметри з адреси, щоб повідомлення не поверталось при F5.
    navigate('/settings', { replace: true });
  }, [location.search, navigate]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.get('highlight') !== 'google-calendar') {
      return;
    }

    setHighlightCalendar(true);

    // Прибираємо параметр з адреси, щоб підсвітка не поверталась при F5.
    navigate('/settings', { replace: true });
  }, [location.search, navigate]);

  // Скрол і зняття підсвітки — ОКРЕМИМ ефектом від прапорця, а не від адреси:
  // navigate вище одразу міняє location.search, і cleanup ефекту, привʼязаного
  // до неї, встиг би вбити обидва таймери ще до їхнього спрацювання.
  useEffect(() => {
    if (!highlightCalendar) {
      return undefined;
    }

    // Скрол — наступним тактом: до нього картка ще не встигла змонтуватись.
    const smooth = !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

    const scrollTimer = setTimeout(() => {
      calendarAnchor.current?.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' });
    }, 120);

    const glowTimer = setTimeout(() => setHighlightCalendar(false), 2600);

    return () => {
      clearTimeout(scrollTimer);
      clearTimeout(glowTimer);
    };
  }, [highlightCalendar]);

  return (
    <div className='settings container'>
      <Head textHead='Налаштування' goBack={''} />

      <div className="settings__content">
        <div className="settings-block">
          <h3 className="settings-block__title">Налаштування нагадуваннь</h3>

          <div className="cards">
            {items.map(item => <CardSettings
              key={item.el}
              title={item.title}
              el={item.el}
              hint={item.hint}
            />)}
          </div>
        </div>

        <div
          id="google-calendar"
          ref={calendarAnchor}
          className={`settings-anchor${highlightCalendar ? ' settings-anchor--highlight' : ''}`}
        >
          <GoogleCalendarCard
            token={token}
            flash={calendarFlash}
            onFlashClose={() => setCalendarFlash(null)}
          />
        </div>

      </div>

    </div>
  );
};

export default Settings;